import { NgModule } from '@angular/core';
import { TopBarComponent } from './top-bar.component';

@NgModule({
  declarations: [TopBarComponent],
  exports: [TopBarComponent],
})
export class TopBarModule {}
